import { LinkTemplateProps } from "../../constants/types";
import LinkDeviceQuantityCard from "../organisms/link/LinkDeviceQuantityCard";
import LinkListCard from "../organisms/link/LinkListCard";
import PublicTemplate from "../publics/PublicTemplate";

const LinkTemplate = (props: LinkTemplateProps) => {
  return (
    <PublicTemplate justify="space-between">
      <>
        <LinkDeviceQuantityCard qty={props.qty} />
        <LinkListCard links={props.links} />
      </>
    </PublicTemplate>
  );
};

export default LinkTemplate;
